import { Link } from '@tanstack/react-router';
import type React from 'react';
import Icon from '~/components2/Icon';

type CivilSearchSubpath = '/projects' | '/requests' | '/agencies' | '/searchers';

interface Props {
  to: CivilSearchSubpath;
  children?: React.ReactNode;
}

const routeMap = {
  '/projects': '/admin/civil-search/projects',
  '/requests': '/admin/civil-search/requests',
  '/agencies': '/admin/civil-search/agencies',
  '/searchers': '/admin/civil-search/searchers',
} as const;

export default function ({ to, children }: Props) {
  return (
    <Link
      to={routeMap[to]}
      className="flex cursor-pointer items-center space-x-1 text-sm font-normal text-primary hover:text-brand"
    >
      <Icon icon="previous" />
      <span>{children}</span>
    </Link>
  );
}
